// extracted by mini-css-extract-plugin
export default {"card-header-left":"card-header-left-a3zM9w","card-content":"card-content-VGLx5d","spacer":"spacer-qHeVVo","closeable-card":"closeable-card-LZxp8y","card-header":"card-header-NaMUxy"};